
import XHeader from 'vux/src/components/x-header/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import { mapState } from 'vuex';
export default {
components: {
XHeader,
Confirm
},
data() {
return {
isAddworkBack: false,
showBack: false,
showHome: false,
showOut: false,
background: '#363539',
color: '#fff',
preventGoBack: true,
showMenus: false
}
},
computed: {
...mapState([
'headerTitle', 'styleColor', 'showHeader'
])
},
watch: {

'$route'(to, from) {
if (
[
"/home",
"/repayment",
"/me",
"/more",
"/login",
"/"
].includes(to.path)
) {
this.showBack = false;
this.background = '#fff';
this.color = '#333333';
} else {
if (!JSON.parse(sessionStorage.getItem('auth_Key')) && this.$store.state.hideTabbar && [
"/testPage",
"/backMoney",
"/productList"
].includes(to.path)) {
this.showBack = false;
this.background = '#fff';
this.color = '#333333';
} else {
this.showBack = true;
this.background = '#fff';
this.color = '#333333';
}
}
/*  if(to.path=='loanApplayForSuccess' && from.path =='confirmLoanInfo'){
this.preventGoBack = true; 
}else{
this.preventGoBack = false;
}*/
}
},
methods: {
clickAlert() {
this.isAddworkBack = true
},
linkHome() {
this.$router.push({ path: '/home' })
},
linkWel() {
this.$router.push({ path: '/' })
},
customBack() { //特殊返回处理
sessionStorage.setItem('auth_Key', false);
this.$store.commit("CHAGNAGESTATE", true);
var path = this.$route.path;
var query = this.$route.query;
if (path == '/myBaoli') {
this.$router.push({ path: '/me' })
} else if (path == '/ConfirmationInfo') {
this.$router.push({ path: '/appendix', query })
} else if (path == '/appendix') {

this.$router.push({ path: '/leasingItemEntry', query })
} else if (path == '/confirmcard') {
this.$router.push({ path: '/applicationProcess', query })
} else if (path == '/informationEntry') {
this.$router.push({ path: '/confirmcard', query })
} else if (path == '/applicationProcess') {
this.$router.push({ path: '/productList', })
} else {
let getUrl = window.location.href

if (getUrl.indexOf('add_order') != -1) {
this.clickAlert()
return false
}
this.$router.go(-1)
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Header.vue